<template>
    <div class="content">
        <div class="row heading-section align-items-center">
            <transition
                appear
                appear-active-class="animate__animated animate__bounceInUp"
                leave-active-class="animate__animated animate__bounceInDown"
                mode="out-in">
                <ExecImageDetails :currentUserMap="currentUserMap" />
            </transition>
            <transition
                appear
                appear-active-class="animate__animated animate__slow animate__fadeIn"
                mode="out-in">
                <ExecContentDetails :currentUserMap="currentUserMap" />
            </transition>
        </div>
        <UserList v-if="currentUserMap" 
            :executives="executives" 
            :execToSkip="currentUserMap.slug" />
    </div>
</template>

<script>
import UserList from '../common/UserList'
import ExecImageDetails from './ExecImageDetails'
import ExecContentDetails from './ExecContentDetails'

export default {
    name: "Details",
    props: ['currentUserMap'],
    metaInfo() {
        return {
            title: this.currentUserMap && this.currentUserMap.title
            ? this.currentUserMap.title.rendered : 'About Us',
        }
    },
    components: {
        UserList,
        ExecImageDetails,
        ExecContentDetails
    },
    computed: {
        executives() {
            return this.$store.state.executives
        },
    }
}
</script>

<style scoped>
.content {
    text-align: left;
    margin: 30px 0;
}
.text-heading {
    font-weight: 600;
}
.icon-image {
    position: relative;
    bottom: 5px;
    left: 10px;
}
hr.divider {
    overflow: visible; /* For IE */
    padding: 0;
    border: none;
    border-top: 2px solid #ece5ec;
    color: #ece5ec;
    text-align: center;
    margin: 50px 0;
}
hr.divider:after {
    content: "WHAT WE DO";
    display: inline-block;
    position: relative;
    top: -0.7em;
    color: #6E2169;
    font-size: 1.5em;
    padding: 0 0.25em;
    background: #F9F9F9;
    padding: 0 5px;
}
@media (min-width: 992px) {
    .details-text {
        margin-bottom: 20px;
    }
}
</style>